import React, { useEffect, useState, forwardRef } from 'react'

import { Timeline, Button, message, Divider } from 'antd'

import { Box } from 'common/components/boxes'
import { Drawer, DrawerRef } from 'common/components/Drawer'

import { DeliveryUpdateParams } from 'vendor/server/deliveries'

import { Receiving, ReceivingProps } from './receiving'
import { Request } from './request'
import { ShippingDetails } from './shipping'

type DeliveryDetailProps = {
  onUpdate: (delivery: DeliveryUpdateParams) => Promise<void>
  orderInfo?: { id: string; vendor_name: string; order_package_name: string }
  onClose: () => void
} & ReceivingProps

export const DeliveryDetail = forwardRef<DrawerRef, DeliveryDetailProps>((props, ref) => {
  const { delivery: deliveryProp, onUpdate, onClose, addExistingFiles, fileList } = props
  // Create a local version of the deliver
  const [delivery, setDelivery] = useState({ ...deliveryProp })

  const [isSubmitting, setSubmitting] = useState(false)

  useEffect(() => setDelivery({ ...deliveryProp }), [deliveryProp])

  const onChange = (paramsToUpdate) => {
    setDelivery({ ...delivery, ...paramsToUpdate })
  }

  const handleUpdate = async () => {
    setSubmitting(true)
    try {
      await onUpdate(delivery)
      message.success('Delivery updated')
    } catch {
      message.error('Unable to update delivery')
    } finally {
      setSubmitting(false)
    }
  }

  const title = delivery.is_pick_up ? 'Pick Up' : 'Delivery'

  return (
    <Drawer ref={ref} onClose={onClose} title={title} bgGray>
      <Box px={{ _: 12, xs: 24 }} py={24} width="100%" height="100%" overflowY="auto">
        <Timeline>
          <Timeline.Item>
            <Request delivery={delivery} />
          </Timeline.Item>
          <Box mt={20} />

          {!delivery.is_pick_up && (
            <>
              <Timeline.Item>
                <ShippingDetails delivery={delivery} onChange={onChange} />
              </Timeline.Item>
              <Box mt={20} />
            </>
          )}

          <Timeline.Item>
            <Receiving delivery={delivery} addExistingFiles={addExistingFiles} fileList={fileList} />
          </Timeline.Item>
        </Timeline>

        <Divider />

        <Box display="flex" justifyContent="space-between">
          <Button onClick={onClose} style={{ width: 100 }} loading={isSubmitting}>
            Cancel
          </Button>

          <Button type="primary" onClick={handleUpdate} style={{ width: 100 }} loading={isSubmitting}>
            OK
          </Button>
        </Box>
      </Box>
    </Drawer>
  )
})
